var _path, _path2, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSpeechBubble = function SvgSpeechBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 94,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4B4B4",
    d: "m16.68 65.766-.272 27.312 27.584-27.04z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    d: "M104.742.734H.26V69.24h104.482z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.639,
    cy: 36.081,
    r: 8.194,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.493,
    cy: 36.077,
    r: 8.194,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.339,
    cy: 36.081,
    r: 8.194,
    fill: "#fff"
  })));
};
export { SvgSpeechBubble as ReactComponent };
export default __webpack_public_path__ + "images/speech-bubble.svg";